import {
  ArrowDownIcon,
  ArrowUpIcon,
  VideoCameraIcon
} from "@heroicons/react/24/outline";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Spinner from "../components/layout/Spinner";
import { initWithDVWCompressedBuffer } from "../components/utils/DVWFile";
import { initWithPSVBCompressedBuffer } from "../components/utils/PSVBFile";
import { useLanguage } from "../context/Language/LanguageContext";
import {
  deleteSession,
  getApiSource,
  getLocalRelayHost,
  getSessionsForServer,
  setApiSource,
  setLocalRelayHost
} from "../context/VBLiveAPI/VBLiveAPIAction";
import VBLiveAPIContext from "../context/VBLiveAPI/VBLiveAPIContext";

function Live() {
  const navigate = useNavigate();
  const { t } = useLanguage();
  const [serverName, setServerName] = useState("");
  const { sessions, dispatch, currentUser } = useContext(VBLiveAPIContext);
  const [sortColumn, setSortColumn] = useState(0);
  const [sortAscending, setSortAscending] = useState(true);
  const [sortedSessions, setSortedSessions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [, forceUpdate] = useState(0);
  const [selectedIds, setSelectedIds] = useState(new Set());
  const [apiSource, setApiSourceState] = useState(getApiSource());
  const [relayHost, setRelayHostState] = useState(getLocalRelayHost());

  const saveApiSource = (src) => {
    setApiSource(src);
    setApiSourceState(src);
  };

  const saveRelayHost = (host) => {
    setLocalRelayHost(host);
    setRelayHostState(host);
  };

  const handleChange = (e) => setServerName(e.target.value);

  const handleSubmit = async (e) => {
    e.preventDefault();
    localStorage.setItem("serverName", serverName);
    setLoading(true);
    if (serverName === "") {
      toast.error(t("Please enter server name to search"));
    } else {
      dispatch({ type: "SET_LOADING" });
      const sessionsData = await getSessionsForServer(serverName);
      //filter sessionsData.sessions to only include sessions that have valid utcLastUpdate
      sessionsData.sessions = sessionsData.sessions.filter(
        (session) => (session.appName === "DVMate" && session.utcLastUpdate) || (session.appName === "VBStats" && session.stats)
      );
      dispatch({ type: "GET_SESSION_INFO_FOR_SERVER", payload: sessionsData });
      const sortedss = sessionsData.sessions.sort((a, b) => b.id - a.id);
      var sss = [];
      for (var session of sortedss) {
        if (session.stats) {
          var m = null;
          if (session.appName === "VBStats") {
            m = initWithPSVBCompressedBuffer(session.stats);
            if (m.TrainingDate) {
              session.dateInSeconds = Date.parse(m.TrainingDate);
              session.date = new Date(
                session.dateInSeconds
              ).toLocaleDateString();
            }
          } else if (session.appName === "DVMate") {
            m = initWithDVWCompressedBuffer(session.stats);
            if (m && m.TrainingDate) {
              session.dateInSeconds = m.TrainingDate
                ? m.TrainingDate.getTime() / 1000
                : 0;
              session.date = m.TrainingDate.toLocaleDateString();
            }
          }
          if (m) {
            session.teamA = m.teamA.name;
            session.teamB = m.teamB.name;
          }
          session.isLive = false;
          if (session.utcLastUpdate) {
            var now = new Date();
            var utc_timestamp = Date.UTC(
              now.getUTCFullYear(),
              now.getUTCMonth(),
              now.getUTCDate(),
              now.getUTCHours(),
              now.getUTCMinutes(),
              now.getUTCSeconds(),
              now.getUTCMilliseconds()
            );
            session.isLive = utc_timestamp / 1000 - session.utcLastUpdate < 300;
          }
          sss.push(session);
        }
      }
      doSort(sss, 1, false);
    }
    setLoading(false);
  };

  const doSort = (aschs, sc, sa) => {
    var xx = null;
    if (sc === 0) {
      xx = sa
        ? aschs.sort((a, b) => a.description.localeCompare(b.description))
        : aschs.sort((a, b) => b.description.localeCompare(a.description));
    } else if (sc === 1) {
      xx = sa
        ? aschs.sort((a, b) => a.dateInSeconds - b.dateInSeconds)
        : aschs.sort((a, b) => b.dateInSeconds - a.dateInSeconds);
    }

    setSortedSessions(xx);
    try {
      const lightSessions = xx.map(({ stats, ...rest }) => rest);
      localStorage.setItem(
        "liveSessions",
        JSON.stringify({ serverName: serverName, sessions: lightSessions })
      );
    } catch (e) {
      // localStorage quota exceeded — cache is best-effort, continue without it
    }
    setSortColumn(sc);
    setSortAscending(sa);
    forceUpdate((n) => !n);
  };

  const toggleSelect = (id) => {
    setSelectedIds((prev) => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });
  };

  const toggleSelectAll = () => {
    if (selectedIds.size === sortedSessions.length) {
      setSelectedIds(new Set());
    } else {
      setSelectedIds(new Set(sortedSessions.map((s) => s.id)));
    }
  };

  const handleDelete = async () => {
    if (selectedIds.size === 0) return;
    if (!window.confirm(t("Delete") + " " + selectedIds.size + " " + t("session(s)?"))) return;
    setLoading(true);
    const ids = Array.from(selectedIds);
    const deletedIds = new Set();
    for (const id of ids) {
      const success = await deleteSession(id);
      if (success) deletedIds.add(id);
    }
    setSortedSessions((prev) => prev.filter((s) => !deletedIds.has(s.id)));
    setSelectedIds((prev) => {
      const next = new Set(prev);
      deletedIds.forEach((id) => next.delete(id));
      return next;
    });
    setLoading(false);
  };

  const doMatch = (session) => {
    const st = {
      sessionId: session.id,
      dvwFileData: null,
    };
    navigate("/session", { state: st });
  };

  const columnHeader = (col, name) => {
    return (
      <th
        onClick={() => {
          var asc = sortColumn === col ? !sortAscending : true;
          doSort(sessions, col, asc);
        }}
        scope="col"
        className="table-header-column text-sm p-2"
      >
        <div className="flex">
          <p>{name}</p>
          {sortColumn === col ? (
            <div>
              {sortAscending ? (
                <ArrowDownIcon
                  className="ml-1 mt-0.5 h-4 w-4 flex-shrink-0"
                  aria-hidden="true"
                />
              ) : (
                <ArrowUpIcon
                  className="ml-1 mt-0.5 h-4 w-4 flex-shrink-0"
                  aria-hidden="true"
                />
              )}
            </div>
          ) : (
            <></>
          )}
        </div>
      </th>
    );
  };

  useEffect(() => {
    const sn = localStorage.getItem("liveSessions");
    if (sn) {
      const ls = JSON.parse(sn);
      setServerName(ls.serverName);
      setSortedSessions(ls.sessions);
    }
  }, []);

  return (
    <>
      {loading ? (
        <Spinner />
      ) : (
        <div className="flex-col">
          <div className="flex items-center gap-2 mt-4">
            <span className="text-sm text-base-content/70">{t("Stats API source")}:</span>
            <div role="tablist" className="tabs tabs-boxed tabs-xs">
              <button
                type="button"
                role="tab"
                className={"tab" + (apiSource === "cloud" ? " tab-active" : "")}
                onClick={() => saveApiSource("cloud")}
              >
                {t("Cloud")}
              </button>
              <button
                type="button"
                role="tab"
                className={"tab" + (apiSource === "local" ? " tab-active" : "")}
                onClick={() => saveApiSource("local")}
              >
                {t("Local")}
              </button>
            </div>
          </div>
          {apiSource === "local" && (
            <div className="flex items-center gap-2 mt-2">
              <span className="text-sm text-base-content/70">{t("Relay host")}:</span>
              <input
                type="text"
                className="input-generic input-sm w-48"
                placeholder="localhost"
                value={relayHost}
                onChange={(e) => saveRelayHost(e.target.value)}
              />
              <span className="text-xs text-base-content/50">
                {t("IP or hostname of the machine running the local relay.")}
              </span>
            </div>
          )}
          <div>
            <p className="text-sm mt-4">{t("Broadcast Server")}</p>
            <form onSubmit={handleSubmit}>
              <div className="form-control pt-1">
                <div className="relative flex gap-2">
                  <input
                    type="text"
                    className="input-generic"
                    placeholder={t("Enter DVMateLive Server Name")}
                    value={serverName}
                    onChange={handleChange}
                  />
                  <button
                    disabled={serverName.length === 0}
                    type="submit"
                    className="btn-in-form"
                  >
                    {t("Load")}
                  </button>
                </div>
              </div>
            </form>
          </div>

          {selectedIds.size > 0 && (
            <div className="flex items-center gap-3 mt-2 mb-1">
              <span className="text-sm">{selectedIds.size} {t("selected")}</span>
              <button
                className="btn btn-error btn-sm"
                onClick={handleDelete}
              >
                {t("Delete")}
              </button>
              <button
                className="btn btn-ghost btn-sm"
                onClick={() => setSelectedIds(new Set())}
              >
                {t("Cancel")}
              </button>
            </div>
          )}

          <div className="overflow-auto h-[80vh]">
            <div className="inline-block min-w-full py-2 align-middle">
              <div className="table-generic">
                <table className="table-generic">
                  <thead className="thead-generic">
                    <tr>
                      <th className="px-2 py-2">
                        <input
                          type="checkbox"
                          className="checkbox checkbox-sm"
                          checked={sortedSessions.length > 0 && selectedIds.size === sortedSessions.length}
                          onChange={toggleSelectAll}
                        />
                      </th>
                      {columnHeader(0, t("Description"))}
                      {columnHeader(1, t("Date"))}
                      <th
                        scope="col"
                        className="px-3 py-2 text-left text-sm font-semibold text-base-content"
                      ></th>
                    </tr>
                  </thead>
                  <tbody className="tbody-generic">
                    {sortedSessions &&
                      sortedSessions.map((session, i) => (
                        <tr
                          key={i}
                          className={`${i % 2 === 0 ? "bg-transparent" : "bg-base-300/10"} ${selectedIds.has(session.id) ? "outline outline-1 outline-primary" : ""}`}
                        >
                          <td className="px-2 py-1">
                            <input
                              type="checkbox"
                              className="checkbox checkbox-sm"
                              checked={selectedIds.has(session.id)}
                              onChange={() => toggleSelect(session.id)}
                            />
                          </td>
                          <td className="table-cell">
                            <div className="flex gap-2">
                              {session.isLive ? (
                                <div className="bg-red-600 text-sm font-bold text-white px-2 cursor-pointer" onClick={() => doMatch(session)}>
                                  {t("LIVE")}
                                </div>
                              ) : (
                                <></>
                              )}

                              <div className="flex gap-1">
                                <div className="">{session.description}</div>
                              </div>
                            </div>
                          </td>
                          <td className="table-cell">
                            <div className="flex gap-2">
                              <div className="">
                                {session.sessionDateString}
                              </div>
                              {/* {session.isLive ? (
                                <div className="bg-red-600 text-sm font-bold text-white px-2">LIVE</div>
                              ) : (
                                <></>
                              )} */}
                            </div>
                          </td>
                          <td className="table-cell">
                            <p className="cursor-pointer flex items-center text-sm text-gray-500">
                              <VideoCameraIcon
                                className={
                                  session.videoOnlineUrl
                                    ? "mr-1.5 h-5 w-5 text-success flex-shrink-0"
                                    : "mr-1.5 h-5 w-5 text-base-content flex-shrink-0"
                                }
                                aria-hidden="true"
                                onClick={() => doMatch(session)}
                              />
                            </p>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Live;
